import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/api-token');

export default {
    get () {
        return api.get('/');
    },
    regenerate(id){
        return api.patch(`/${id}/regenerate`);
    },
}
